const DEFAULT_LANGUAGE = 'ENG';

export const getLocalizedBonusInfo = (bonus, language = DEFAULT_LANGUAGE) => {
  const normalizedBonus = bonus?.bonus ?? bonus;
  const { localizedInfoList = [], name, nameHighlighted } = normalizedBonus ?? {};
  const currentLanguage = language?.toLowerCase();
  const localizedInfo =
    localizedInfoList.find(info => info.language?.toLowerCase() === currentLanguage) ??
    localizedInfoList[0];

  return {
    name: localizedInfo?.name ?? name,
    nameHighlighted: localizedInfo?.nameHighlighted ?? nameHighlighted,
  };
};

const getBonusActivationToastId = data => {
  const bonusId = data?.bonusId ?? data?.bonus?.id ?? data?.id;

  return bonusId != null ? `bonus-activation-success-${bonusId}` : null;
};

export const getBonusActivationToastOptions = (data, language = DEFAULT_LANGUAGE) => {
  const { bonus, bonusName, bonusNameHighlighted, name, nameHighlighted } = data ?? {};
  const localizedInfo = getLocalizedBonusInfo(data, language);
  const id = getBonusActivationToastId(data);
  const options = {
    data: {
      bonusName: bonusName ?? name ?? localizedInfo.name ?? bonus ?? null,
      bonusNameHighlighted:
        bonusNameHighlighted ?? nameHighlighted ?? localizedInfo.nameHighlighted ?? null,
    },
    type: 'bonusActivationSuccess',
  };

  return id ? { ...options, id } : options;
};
